module.exports = __webpack_public_path__ + "media/images/slider_img_04-4ab6b36ae773393172a78c05004f7860.png";